import { AtlasV2OrganicTrafficV2PageLayout } from 'src/components/AtlasV2Components/AtlasV2PageLayouts/AtlasV2OrganicTrafficV2PageLayout';
import { AtlasV2OtherTrafficV2PageLayout } from 'src/components/AtlasV2Components/AtlasV2PageLayouts/AtlasV2OtherTrafficV2PageLayout';
import { AtlasV2PaidTrafficV2PageLayout } from 'src/components/AtlasV2Components/AtlasV2PageLayouts/AtlasV2PaidTrafficV2PageLayout';
import { AtlasV2TotalTrafficV2PageLayout } from 'src/components/AtlasV2Components/AtlasV2PageLayouts/AtlasV2TotalTrafficV2PageLayout';
import GenericPageContainer from 'src/components/EntityPage/GenericPageContainer';

export default function getAtlasTrafficLayout({ metricType }) {
  const trafficPageLayout = {
    totalClicks: AtlasV2TotalTrafficV2PageLayout,
    organicClicks: AtlasV2OrganicTrafficV2PageLayout,
    adClicks: AtlasV2PaidTrafficV2PageLayout,
    otherClicks: AtlasV2OtherTrafficV2PageLayout
  };
  return {
    CustomPageContainer: GenericPageContainer,
    enableComparison: false,
    widgets: [
      {
        name: 'trafficV2PageLayout',
        CustomComponent: trafficPageLayout[metricType],
        view: {}
      }
    ],
    containerStyle: {},
    dataConfig: {}
  };
}
